// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","pageLayout":"lJheicP0YjDt6w3Y-r2_N","leftSideColumn":"_2LEhMBFAIowBC_2HpRoVcJ","rightSideColumn":"_3TUefOm0XhLL1SP4QdAwKs"};